import { HOST_URL } from 'config';
import AjaxUtil from 'common/Js/AjaxHelper/AjaxUtil';
const ACCOUNT_API = '/WebApp/Account';
const RESET_PASSWORD_API = '/WebApp/ResetPassword';

export const SIGNIN_URL = `${HOST_URL}${ACCOUNT_API}/Login`;

export const postLoginCredentials = (user_name, user_passowrd) => {
  const url = `${HOST_URL}${ACCOUNT_API}/Login`;
  return AjaxUtil.genericSendPost(url, JSON.stringify({ user_name, user_passowrd }));
};

export const contactUser = byPhone => {
  const url = `${HOST_URL}${ACCOUNT_API}/ContactUser`;
  const data = { should_call_user: byPhone };
  return AjaxUtil.genericSendPost(url, JSON.stringify(data));
};

export const postPhonePincode = phonePincode => {
  const url = `${HOST_URL}${ACCOUNT_API}/PhoneVerification`;
  return AjaxUtil.genericSendPost(url, JSON.stringify({ phone_verification_pin: phonePincode }));
};

export const postQrPincode = qrPincode => {
  const url = `${HOST_URL}${ACCOUNT_API}/QrVerification`;
  return AjaxUtil.genericSendPost(url, JSON.stringify({ qr_verification_pin: qrPincode }));
};

export const getResetPasswordRequest = email => {
  const url = `${HOST_URL}${RESET_PASSWORD_API}/ResetPasswordRequest?email=${email}`;
  return AjaxUtil.sendGet(url);
};

export const postResetPassword = (email, password, token) => {
  const url = `${HOST_URL}${RESET_PASSWORD_API}/ResetPassword`;
  return AjaxUtil.genericSendPost(
    url,
    JSON.stringify({
      Email: email,
      Password: password,
      Token: token
    })
  );
};

export const postForgotPassword = email => {
  const url = `${HOST_URL}${ACCOUNT_API}/ForgotPassword`;
  return AjaxUtil.genericSendPost(url, JSON.stringify({ email: email }));
};
